import { useState } from 'react'
import {
	EuiButton,
	EuiButtonIcon,
	EuiModalBody,
	EuiModalFooter,
} from '@equipmentshare/ds2'
import PartPicker from '../../../../../components/PartPicker'
import { Part } from 'graphql'

import styles from './merge-parts-form.module.css'

export type MergePartsFormProps = {
  fromPart?: Part,
  onCancel: () => void,
  onSuccess: () => void,
  onSubmit: ( goodPartId: number, dupePartId: number ) => Promise<any>,
}

export default function MergePartsForm( { fromPart, onCancel, onSuccess, onSubmit }: MergePartsFormProps ): JSX.Element {
	const [ goodPart, setGoodPart ] = useState<Part | undefined>( fromPart )
	const [ duplicatePart, setDuplicatePart ] = useState<Part | undefined>()
	const [ isSaving, setIsSaving ] = useState( false )

	const handleSelectGoodPart = ( _: any, part?: Part ) => setGoodPart( part )
	const handleSelectDupePart = ( _: any, part?: Part ) => setDuplicatePart( part )

	const handleSwapParts = () => {
		setDuplicatePart( goodPart )
		setGoodPart( duplicatePart )
	}

	const handleSubmit = async() => {
		if ( goodPart && duplicatePart ) {
			setIsSaving( true )
			await onSubmit( goodPart.id, duplicatePart.id )
			setIsSaving( false )
			onSuccess()
		}
	}

	const isValid = goodPart && duplicatePart
	const duplicateHasVendorInfo = !!duplicatePart?.vendors?.length

	return (
		<>
			<EuiModalBody>
				<PartPicker
					id="goodPart"
					label="Good Product"
					onChange={handleSelectGoodPart}
					selectedPart={goodPart}
					required
				/>
				<EuiButtonIcon
					id="swapBtn"
					className={styles.swapButton}
					iconType="merge"
					size="m"
					iconSize="xl"
					color="text"
					aria-label="Swap Products"
					title="Swap Products"
					onClick={handleSwapParts}
				/>
				<PartPicker
					id="duplicatePart"
					label="Duplicate Product"
					onChange={handleSelectDupePart}
					selectedPart={duplicatePart}
					required
				/>

				<div className={styles.warningContainer}>
					<div className={styles.warning}>
						Warning: the duplicate product will be removed, and the good product selected above will take over its assignments.
					</div>
					{duplicateHasVendorInfo && (
						<div className={styles.warning}>
							Warning: all vendor information on the duplicate product will be discarded.
						</div>
					)}
					<div className={styles.warningBold}>
						This action cannot be undone!
					</div>
				</div>
			</EuiModalBody>
			<EuiModalFooter>
				<EuiButton
					id="cancelBtn"
					color="text"
					onClick={onCancel}
				>
          Cancel
				</EuiButton>
				<EuiButton
					id="submitBtn"
					fill
					isDisabled={!isValid}
					isLoading={isSaving}
					onClick={handleSubmit}
				>
          Submit
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
